export const revenueOperationsInsightsArticle = {
  title: 'Revenue Operations Hub: Dashboard & Insights',
  slug: 'revenue-operations-insights',
  content: `Revenue Operations Hub: Dashboard & Insights

Monitor revenue health and AI recommendations.

1) Dashboard overview
- Open /finance-hub#dashboard.
- Review revenue, expenses, gross profit, margin, and runway.
- Use the period selector to change the time window.

2) Insights recommendations
- Open /finance-hub#insights.
- Review alerts (e.g., low margin or limited runway).
- Save a snapshot to capture the current period summary.

3) Follow related actions
- Links in insights route to Pricing Hub or Forecasting Hub when relevant.
`,
};
